
import React, { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingScreenProps {
  minDisplayTime?: number;
}

const LoadingScreen: React.FC<LoadingScreenProps> = ({ minDisplayTime = 1500 }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Ensure minimum display time for the loader
    const minTimeTimer = setTimeout(() => {
      setIsVisible(false);
    }, minDisplayTime);

    // Simulate progress for visual feedback
    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        const newProgress = prev + Math.random() * 15;
        return newProgress > 100 ? 100 : newProgress;
      });
    }, 200);

    // Listen for window load event
    const handleLoad = () => {
      setProgress(100);
      setTimeout(() => setIsVisible(false), 300);
    };

    window.addEventListener('load', handleLoad);

    return () => {
      clearTimeout(minTimeTimer);
      clearInterval(progressInterval);
      window.removeEventListener('load', handleLoad);
    };
  }, [minDisplayTime]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-cream z-50 flex flex-col items-center justify-center">
      <div className="relative w-48 h-48 mb-6">
        {/* Decorative leaves */}
        <div className="absolute -top-12 -left-12 w-24 h-24 opacity-20 rotate-45 transform">
          <img 
            src="/lovable-uploads/leaf-decoration.png" 
            alt="" 
            className="w-full h-full object-contain"
          />
        </div>
        <div className="absolute -bottom-12 -right-12 w-24 h-24 opacity-20 -rotate-45 transform">
          <img 
            src="/lovable-uploads/leaf-decoration.png" 
            alt="" 
            className="w-full h-full object-contain"
          />
        </div>
        
        {/* Main decoration */}
        <div className="w-full h-full animate-pulse flex items-center justify-center">
          <div className="w-40 h-40 rounded-full border-4 border-sage/30 p-4 flex items-center justify-center">
            <div className="text-center">
              <h1 className="text-4xl font-parisienne text-forest">
                E&C
              </h1>
              <div className="w-12 h-px bg-forest/40 mx-auto my-2"></div>
              <p className="text-sm text-forest/70 font-italiana">16.08.2025</p>
            </div>
          </div>
        </div>
      </div>
      
      <h1 className="text-3xl md:text-4xl font-parisienne text-forest mb-6">
        Emi & Carlos
      </h1>
      
      <div className="relative w-64 mb-6">
        <Loader2 className="h-8 w-8 text-forest/60 animate-spin mx-auto mb-4" />
        <p className="text-center text-forest/70 text-sm mb-3 font-italiana">Cargando nuestra historia...</p>
        <div className="w-full h-1 bg-sage/20 rounded-full overflow-hidden">
          <div 
            className="h-full bg-sage/40 transition-all duration-300 rounded-full" 
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
